import * as connectedReactRouter from 'connected-react-router'
import routes from '../../../config/routes'
import * as authentication from '../../../lib/authentication'
import * as types from './types'
import * as integration from '../../../integration'
import * as auth from '../auth'
import * as newCurrentUser from '../currentUser'
import * as modal from '../modal'
import * as modals from '../../../constants/modals'
// eslint-disable-next-line import/no-cycle
import * as users from '../users'

// Errors

export const ERROR_MESSAGES = {
  Unauthorized: {
    messages: [
      'Você inseriu um endereço de e-mail ou senha incorreta.',
      'Após a terceira tentativa, a sua conta será bloqueada!'
    ]
  },
  Blocked: {
    messages: [
      'A sua conta está temporariamente bloqueada',
      'Por motivos de segunça, a sua conta está bloqueada por tentativas de login com o endereço de e-mail ou senha inválida.'
    ]
  }
}

export const blockedRedirect = (name) => (dispatch) => {
  if (name !== 'Blocked') return false

  return dispatch(
    connectedReactRouter.routerActions.push(routes.loginBlocked.path)
  )
}

export const receiveError =
  (error = {}) =>
  (dispatch) => {
    const { name } = error

    const err = ERROR_MESSAGES[name] || ERROR_MESSAGES.Unauthorized

    dispatch(blockedRedirect(name))

    const newError = {
      hasError: true,
      messages: err?.messages
    }

    return dispatch({
      type: types.RECEIVE_SESSION_ERROR,
      payload: newError
    })
  }

export const resetError = () => ({
  type: types.RESET_SESSION_ERROR
})

// General Session

export const fetchSession = (value = true) => [
  resetError(),
  {
    type: types.FETCH_SESSION,
    payload: value
  }
]

export const receiveSession = (data) => ({
  type: types.RECEIVE_SESSION,
  payload: data
})

// Pre Login

export const receivePreLogin = (credentials, status, slt) => (dispatch) => {
  authentication.emailCache(credentials)
  dispatch(auth.actions.receiveAuthSLT(slt))
  dispatch(
    receiveSession({
      credentials,
      status
    })
  )
  dispatch(connectedReactRouter.routerActions.push(routes.loginAuth.path))
}

export const preLoginStatusActions =
  (status, id, slt, credentials) => (dispatch) => {
    if (status === 1) {
      dispatch(auth.actions.receiveAuthSLT(slt))
      dispatch(
        users.actions.receiveResentDatasAndConfirmUserPhone(id, credentials)
      )

      return
    }

    if (status === 2) {
      dispatch(
        users.actions.receiveResentDatasAndConfirmUserEmail(id, credentials)
      )

      return
    }

    if (status === 3) {
      dispatch(
        connectedReactRouter.routerActions.push(routes.awaitingApproval.path)
      )
      return
    }

    dispatch(receivePreLogin(credentials, status, slt))
  }

export const preLogin = (credentials) => async (dispatch) => {
  const { email, password } = credentials

  dispatch(fetchSession())

  try {
    const res = await integration.resources.session.requests.preLogin({
      email,
      password
    })

    const { data } = res

    dispatch(
      preLoginStatusActions(data?.status, data?.id, data?.slt, credentials)
    )

    return data
  } catch (err) {
    dispatch(fetchSession(false))
    dispatch(receiveError(err?.error?.metadata?.errorData))

    return Promise.reject(err)
  }
}

export const resentPreLogin = () => (dispatch, getState) => {
  const { credentials } = getState().sessionReducer.content

  dispatch(preLogin(credentials))
  dispatch(modal.actions.receiveModal(modals.AUTH_RESENT_MODAL_ID))
}

// Login

export const receiveLogin = () => ({ type: types.RECEIVE_LOGIN })

export const loginStatusActions = (status) => (dispatch) => {
  if (status === 6) {
    dispatch(connectedReactRouter.routerActions.push(routes.terms.path))

    return
  }

  if (status === 7) {
    dispatch(connectedReactRouter.routerActions.push(routes.wallet.path))
  }
}

export const login = (data) => async (dispatch, getState) => {
  dispatch(fetchSession())

  const slt = dispatch(auth.actions.getAuthSLT())

  const state = getState()?.sessionReducer?.content || {}

  const { credentials: { email, password } = {}, status } = state

  const values = {
    email,
    password,
    code: data?.code
  }

  try {
    const res = await integration.resources.session.requests.login(values, slt)

    authentication.setAccessToken(res?.data?.auth?.token)

    const userId = res?.data?.user?.stdCode

    authentication.setUserId(userId)

    if (window && window.pendo) {
      window.pendo.initialize({
        visitor: {
          id: userId,
          email,
          full_name: res?.data?.user?.name
        }
      })
    }

    dispatch(auth.actions.resetAuth())

    dispatch(receiveLogin())

    dispatch(loginStatusActions(status))

    dispatch(newCurrentUser.actions.fetchInitialData())

    dispatch(newCurrentUser.actions.reveiveRoles(res.data.user.roles))

    if (res.data.user.businessCode) {
      dispatch(
        newCurrentUser.actions.receiveBusinessCode(res.data.user.businessCode)
      )
    }

    dispatch(
      newCurrentUser.actions.receiveDashboards(res.data.user.dashboards ?? [])
    )

    const { acceptedCommitmentTermAt, acceptedResponsibilityTermAt } =
      res.data.user

    dispatch(
      newCurrentUser.actions.receiveTerms({
        acceptedCommitmentTermAt,
        acceptedResponsibilityTermAt
      })
    )
  } catch (err) {
    dispatch(fetchSession(false))
    dispatch(auth.actions.receiveError())
  }
}

// Authenticate
export const unauthorized = () =>
  connectedReactRouter.routerActions.push(routes.login.path)

export const authenticate = () => (dispatch) => {
  const token = authentication.getAccessToken()

  if (!token) {
    dispatch(unauthorized())

    return false
  }

  return true
}

export const loggedIn = () => !!authentication.getAccessToken()

// eslint-disable-next-line consistent-return
export const logout = () => async (dispatch) => {
  try {
    await integration.resources.session.requests.logout()
    authentication.removeAccessToken()
    dispatch(auth.actions.resetAuth())
    dispatch(newCurrentUser.actions.clearAll())
    dispatch(connectedReactRouter.routerActions.push(routes.login.path))
    localStorage.clear(`persist:root`)
    window.location.reload()
  } catch (err) {
    return Promise.reject(err)
  }
}
